import '.ds{font-size:1.125rem;}.ssr-plugin'
import '.f7{line-height:1.75rem;}.ssr-plugin'
import '.e7{text-decoration:none;}.ssr-plugin'
import '.gm{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="ds f7"
    >
      {translations.privacySubtitle}{' '}
      <a className="e7 gm"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="e7 gm"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
